// src/pages/Dashboard/components/CasePanel/JurisprudenceSection/JurisprudenceTable.js

import React from 'react';
import JurisprudenceTableRow from './JurisprudenceTableRow';

/**
 * Tabela de jurisprudências relacionadas
 * @param {Array} jurisprudencias - Lista de jurisprudências
 * @param {function} onViewDetails - Callback para ver detalhes
 * @param {function} onRemove - Callback para remover
 */
const JurisprudenceTable = ({ jurisprudencias, onViewDetails, onRemove }) => {
  const handleRowClick = (juris, event) => {
    // Não fazer nada se clicou no botão remover
    if (event.target.closest('.btn-remover')) {
      return;
    }
    onViewDetails(juris);
  };

  return (
    <div className="jurisprudencias-lista-dashboard">
      <div className="jurisprudencias-table">
        <div className="table-header-dashboard">
          <div className="col-tribunal-dashboard">Tribunal</div>
          <div className="col-data-dashboard">Data</div>
          <div className="col-processo-dashboard">Meio</div>
          <div className="col-acoes-dashboard">REM</div>
        </div>
        {jurisprudencias.map((juris) => (
          <JurisprudenceTableRow
            key={juris.id}
            jurisprudencia={juris}
            onClick={handleRowClick}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );
};

export default JurisprudenceTable;